import { defineProperty as _defineProperty, toConsumableArray as _toConsumableArray, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { addBreakpointMedia, objectDeepMerging, ThemeBreakpoints, isString } from '../../utils/index.js';
import { createStyles } from '@mantine/core';
import { useInputAppStyle } from './Input.app.style.js';
import { RootVariableForInput, RootVariable } from './constant.js';

var _defaultVariable, _defaultWrapperVariab;
var resetVariable = Object.values(RootVariableForInput).reduce(function (ac, cr) {
  ac[cr] = 'none';
  return ac;
}, {});
var defaultVariable = (_defaultVariable = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defaultVariable, RootVariable.INPUT_FONT_WEIGHT, 500), RootVariable.INPUT_COLOR, 'var(--gui-color-text-1)'), RootVariable.INPUT_ICON_COLOR, 'var(--gui-color-icon-1)'), RootVariable.INPUT_INVALID_COLOR, 'var(--gui-color-text-1)'), RootVariable.INPUT_DISABLED_COLOR, 'var(--gui-color-text-7)'), RootVariable.INPUT_BORDER_WIDTH, '1px'), RootVariable.INPUT_HOVER_BORDER_COLOR, 'var(--gui-color-text-9)'), RootVariable.INPUT_ACTIVE_BORDER_COLOR, 'var(--gui-color-text-9)'), RootVariable.INPUT_INVALID_BORDER_COLOR, 'var(--gui-color-funct-3)'), RootVariable.INPUT_DISABLED_BORDER_COLOR, 'var(--gui-color-divider-5)'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defaultVariable, RootVariable.INPUT_PLACEHOLDER_COLOR, 'var(--gui-color-text-3)'), RootVariable.INPUT_DISABLED_PLACEHOLDER_COLOR, 'var(--gui-color-text-7)'), RootVariable.INPUT_INVALID_PLACEHOLDER_COLOR, 'var(--gui-color-text-1)'), RootVariable.INPUT_PLACEHOLDER_FONT_WEIGHT, 500), RootVariable.INPUT_CLEAR_ICON_COLOR, 'var(--gui-color-icon-3)'), RootVariable.INPUT_DISABLED_ICON_COLOR, 'var(--gui-color-icon-7)'));
var defaultWrapperVariable = (_defaultWrapperVariab = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defaultWrapperVariab, RootVariable.INPUT_WRAPPER_LABEL_FONT_SIZE, '14px'), RootVariable.INPUT_WRAPPER_DESC_FONT_SIZE, '12px'), RootVariable.INPUT_WRAPPER_ERROR_FONT_SIZE, '12px'), RootVariable.INPUT_WRAPPER_LABEL_FONT_WEIGHT, 400), RootVariable.INPUT_WRAPPER_DESC_FONT_WEIGHT, 400), RootVariable.INPUT_WRAPPER_ERROR_FONT_WEIGHT, 400), RootVariable.INPUT_WRAPPER_REQUIRED_COLOR, 'var(--gui-color-other-3)'), RootVariable.INPUT_WRAPPER_LABEL_COLOR, 'var(--gui-color-text-1)'), RootVariable.INPUT_WRAPPER_DESC_COLOR, 'var(--gui-color-text-3)'), RootVariable.INPUT_WRAPPER_ERROR_COLOR, 'var(--gui-color-funct-3)'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defaultWrapperVariab, RootVariable.INPUT_WRAPPER_LABEL_GAP, '6px'), RootVariable.INPUT_WRAPPER_DESC_GAP, '6px'), RootVariable.INPUT_WRAPPER_ERROR_GAP, '6px'), RootVariable.INPUT_WRAPPER_LABEL_LINE_HEIGHT, 1.2), RootVariable.INPUT_WRAPPER_ERROR_LINE_HEIGHT, 1.5), RootVariable.INPUT_WRAPPER_DESC_LINE_HEIGHT, 1.5));
var getDefaultStyles = function getDefaultStyles() {
  return {
    wrapper: _objectSpread2(_objectSpread2({}, resetVariable), defaultVariable)
  };
};
var getWrapperDefaultStyles = function getWrapperDefaultStyles() {
  return {
    root: _objectSpread2({}, defaultWrapperVariable)
  };
};
var getPrimaryStyles = function getPrimaryStyles() {
  return {
    wrapper: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RootVariable.INPUT_BG, 'var(--gui-color-neutral-7)'), RootVariable.INPUT_HOVER_BG, 'var(--gui-color-neutral-7)'), RootVariable.INPUT_ACTIVE_BG, 'var(--gui-color-neutral-7)'), RootVariable.INPUT_DISABLED_BG, 'var(--gui-color-cmpt-25)'), RootVariable.INPUT_BORDER_WIDTH, '1px'), RootVariable.INPUT_BORDER_COLOR, 'var(--gui-color-divider-5)'), RootVariable.INPUT_HOVER_BORDER_COLOR, 'var(--gui-color-text-1)'), RootVariable.INPUT_ACTIVE_BORDER_COLOR, 'var(--gui-color-text-1)'), RootVariable.INPUT_INVALID_BORDER_COLOR, 'var(--gui-color-funct-3)'), RootVariable.INPUT_DISABLED_BORDER_COLOR, 'var(--gui-color-divider-5)')
  };
};
var getOutlinedStyles = function getOutlinedStyles() {
  return {
    wrapper: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RootVariable.INPUT_DISABLED_BG, 'var(--gui-color-cmpt-2)'), RootVariable.INPUT_BORDER_WIDTH, '1px'), RootVariable.INPUT_BORDER_COLOR, 'var(--gui-color-divider-5)'), RootVariable.INPUT_HOVER_BORDER_COLOR, 'var(--gui-color-text-9)'), RootVariable.INPUT_ACTIVE_BORDER_COLOR, 'var(--gui-color-text-9)'), RootVariable.INPUT_INVALID_BORDER_COLOR, 'var(--gui-color-funct-3)'), RootVariable.INPUT_DISABLED_BORDER_COLOR, 'var(--gui-color-divider-5)'), RootVariable.INPUT_BG, 'transparent'), RootVariable.INPUT_HOVER_BG, 'transparent'), RootVariable.INPUT_ACTIVE_BG, 'transparent')
  };
};
var getLgSharedStyles = function getLgSharedStyles() {
  return {
    wrapper: _defineProperty({}, RootVariable.INPUT_RADIUS, '6px')
  };
};
var getMdSharedStyles = function getMdSharedStyles() {
  return {
    wrapper: _defineProperty({}, RootVariable.INPUT_RADIUS, '6px')
  };
};
var getSmSharedStyles = function getSmSharedStyles() {
  return {
    wrapper: _defineProperty({}, RootVariable.INPUT_RADIUS, '6px')
  };
};
var getXsSharedStyles = function getXsSharedStyles() {
  return {
    wrapper: _defineProperty({}, RootVariable.INPUT_RADIUS, '4px')
  };
};
var getLgStyles = function getLgStyles() {
  return objectDeepMerging(getLgSharedStyles(), {
    wrapper: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RootVariable.INPUT_HEIGHT, '48px'), RootVariable.INPUT_FONT_SIZE, '14px'), RootVariable.INPUT_ICON_SIZE, '20px'), RootVariable.INPUT_CLEAR_ICON_SIZE, '20px'), RootVariable.INPUT_BASE_PADDING, '16px'), RootVariable.INPUT_ICON_MARGIN, '8px')
  });
};
var getMdStyles = function getMdStyles() {
  return objectDeepMerging(getMdSharedStyles(), {
    wrapper: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RootVariable.INPUT_HEIGHT, '40px'), RootVariable.INPUT_FONT_SIZE, '14px'), RootVariable.INPUT_ICON_SIZE, '16px'), RootVariable.INPUT_CLEAR_ICON_SIZE, '18px'), RootVariable.INPUT_BASE_PADDING, '12px'), RootVariable.INPUT_ICON_MARGIN, '8px')
  });
};
var getSmStyles = function getSmStyles() {
  return objectDeepMerging(getSmSharedStyles(), {
    wrapper: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RootVariable.INPUT_HEIGHT, '32px'), RootVariable.INPUT_FONT_SIZE, '12px'), RootVariable.INPUT_ICON_SIZE, '14px'), RootVariable.INPUT_CLEAR_ICON_SIZE, '16px'), RootVariable.INPUT_BASE_PADDING, '8px'), RootVariable.INPUT_ICON_MARGIN, '8px')
  });
};
var getXsStyles = function getXsStyles() {
  return objectDeepMerging(getXsSharedStyles(), {
    wrapper: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RootVariable.INPUT_HEIGHT, '24px'), RootVariable.INPUT_FONT_SIZE, '12px'), RootVariable.INPUT_ICON_SIZE, '14px'), RootVariable.INPUT_CLEAR_ICON_SIZE, '16px'), RootVariable.INPUT_BASE_PADDING, '8px'), RootVariable.INPUT_ICON_MARGIN, '4px')
  });
};
var getXsWrapperStyles = function getXsWrapperStyles() {
  return {
    root: _defineProperty({}, RootVariable.INPUT_WRAPPER_LABEL_FONT_SIZE, '12px')
  };
};
var getCurrentVariantAndSizeStyle = function getCurrentVariantAndSizeStyle(_ref) {
  var type = _ref.type,
    size = _ref.size;
  return objectDeepMerging(getDefaultStyles(), _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, size === 'lg' ? getLgStyles() : {}), size === 'md' ? getMdStyles() : {}), size === 'sm' ? getSmStyles() : {}), size === 'xs' ? getXsStyles() : {}), _objectSpread2(_objectSpread2({}, type === 'primary' ? getPrimaryStyles() : {}), type === 'outlined' ? getOutlinedStyles() : {}));
};
var getGroupCurrentVariantAndSizeStyle = function getGroupCurrentVariantAndSizeStyle(_ref2) {
  var type = _ref2.type,
    size = _ref2.size;
  return objectDeepMerging(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, size === 'lg' ? {
    root: getLgSharedStyles().wrapper
  } : {}), size === 'md' ? {
    root: getMdSharedStyles().wrapper
  } : {}), size === 'sm' ? {
    root: getSmSharedStyles().wrapper
  } : {}), size === 'xs' ? {
    root: getXsSharedStyles().wrapper
  } : {}), _objectSpread2(_objectSpread2({}, type === 'primary' ? {
    root: getPrimaryStyles().wrapper
  } : {}), type === 'outlined' ? {
    root: getOutlinedStyles().wrapper
  } : {}));
};
var getWrapperCurrentVariantAndSizeStyle = function getWrapperCurrentVariantAndSizeStyle(_ref3) {
  var size = _ref3.size;
  return objectDeepMerging(getWrapperDefaultStyles(), _objectSpread2({}, size === 'xs' ? getXsWrapperStyles() : {}));
};
var useInputStyle = createStyles(function (_, params, getRef) {
  var type = params.type,
    size = params.size,
    hasLeft = params.hasLeft,
    hasRight = params.hasRight,
    hasClear = params.hasClear,
    breakpoints = params.breakpoints,
    isH5MappingAppStyle = params.isH5MappingAppStyle;
  var appStyle = useInputAppStyle({
    size: size
  });
  return addBreakpointMedia(function (_ref4) {
    var size = _ref4.size;
    return objectDeepMerging(getCurrentVariantAndSizeStyle({
      size: size,
      type: type
    }), {
      input: _defineProperty({
        fontFamily: 'inherit',
        fontWeight: 500,
        padding: "0 var(".concat(RootVariable.INPUT_BASE_PADDING, ")"),
        color: "var(".concat(RootVariable.INPUT_COLOR, ")"),
        borderRadius: "var(".concat(RootVariable.INPUT_RADIUS, ")"),
        paddingLeft: hasLeft && "calc(var(".concat(RootVariable.INPUT_BASE_PADDING, ") + var(").concat(RootVariable.INPUT_ICON_SIZE, ") + var(").concat(RootVariable.INPUT_ICON_MARGIN, ")) !important"),
        paddingRight: hasClear && "calc(var(".concat(RootVariable.INPUT_BASE_PADDING, ") + var(").concat(RootVariable.INPUT_CLEAR_ICON_SIZE, ") + var(").concat(RootVariable.INPUT_ICON_MARGIN, ")) !important"),
        border: "var(".concat(RootVariable.INPUT_BORDER_WIDTH, ") solid var(").concat(RootVariable.INPUT_BORDER_COLOR, ")"),
        minHeight: "var(".concat(RootVariable.INPUT_HEIGHT, ")"),
        height: "var(".concat(RootVariable.INPUT_HEIGHT, ")"),
        fontSize: "var(".concat(RootVariable.INPUT_FONT_SIZE, ")"),
        background: "var(".concat(RootVariable.INPUT_BG, ")"),
        lineHeight: 1.5,
        '@media(hover:hover)': _defineProperty(_defineProperty({
          '&:hover:not(:disabled):not([aria-invalid="true"])': {
            border: "var(".concat(RootVariable.INPUT_BORDER_WIDTH, ") solid var(").concat(RootVariable.INPUT_HOVER_BORDER_COLOR, ")"),
            background: "var(".concat(RootVariable.INPUT_HOVER_BG, ")")
          }
        }, "&:not(:placeholder-shown):not(:disabled):hover+.".concat(getRef('rightSection'), ">.").concat(getRef('clear')), {
          display: 'block'
        }), "&:not(:placeholder-shown):not(:disabled)+.".concat(getRef('rightSection'), ">.").concat(getRef('clear'), ":hover"), {
          display: 'block'
        }),
        '@media(hover:none)': _defineProperty(_defineProperty({
          '&:focus:not(:disabled):not([aria-invalid="true"])': {
            border: "var(".concat(RootVariable.INPUT_BORDER_WIDTH, ") solid var(").concat(RootVariable.INPUT_BORDER_COLOR, ")"),
            background: "var(".concat(RootVariable.INPUT_BG, ")")
          }
        }, "&:not(:placeholder-shown):not(:disabled):focus+.".concat(getRef('rightSection'), ">.").concat(getRef('clear')), {
          display: 'block'
        }), "&:not(:placeholder-shown):not(:disabled)+.".concat(getRef('rightSection'), ">.").concat(getRef('clear'), ":focus"), {
          display: 'block'
        }),
        '&:focus:not(:disabled):not([aria-invalid="true"])': {
          border: "var(".concat(RootVariable.INPUT_BORDER_WIDTH, ") solid var(").concat(RootVariable.INPUT_ACTIVE_BORDER_COLOR, ")"),
          background: "var(".concat(RootVariable.INPUT_ACTIVE_BG, ")")
        },
        '&::placeholder': {
          color: "var(".concat(RootVariable.INPUT_PLACEHOLDER_COLOR, ")"),
          fontWeight: "var(".concat(RootVariable.INPUT_PLACEHOLDER_FONT_WEIGHT, ")"),
          fontSize: "var(".concat(RootVariable.INPUT_PLACEHOLDER_FONT_SIZE, ")")
        },
        '&:disabled::placeholder': {
          color: "var(".concat(RootVariable.INPUT_DISABLED_PLACEHOLDER_COLOR, ")")
        },
        '&[aria-invalid="true"]::placeholder': {
          color: "var(".concat(RootVariable.INPUT_INVALID_PLACEHOLDER_COLOR, ")")
        },
        '&[aria-invalid="true"]': {
          color: "var(".concat(RootVariable.INPUT_INVALID_COLOR, ")"),
          border: "var(".concat(RootVariable.INPUT_BORDER_WIDTH, ") solid var(").concat(RootVariable.INPUT_INVALID_BORDER_COLOR, ")")
        },
        '&:disabled': {
          background: "var(".concat(RootVariable.INPUT_DISABLED_BG, ")"),
          color: "var(".concat(RootVariable.INPUT_DISABLED_COLOR, ")"),
          opacity: 1,
          border: "var(".concat(RootVariable.INPUT_BORDER_WIDTH, ") solid var(").concat(RootVariable.INPUT_DISABLED_BORDER_COLOR, ")")
        }
      }, "&:disabled+.".concat(getRef('rightSection')), {
        color: "var(".concat(RootVariable.INPUT_DISABLED_ICON_COLOR, ")")
      }),
      wrapper: {
        margin: 0
      },
      rightSection: {
        ref: getRef('rightSection'),
        color: "var(".concat(RootVariable.INPUT_ICON_COLOR, ")"),
        fontWeight: 400,
        fontSize: "var(".concat(RootVariable.INPUT_ICON_SIZE, ")"),
        lineHeight: "var(".concat(RootVariable.INPUT_ICON_SIZE, ")"),
        right: "var(".concat(RootVariable.INPUT_BASE_PADDING, ")"),
        width: 'fit-content',
        fill: "var(".concat(RootVariable.INPUT_ICON_COLOR, ")")
      },
      icon: {
        left: "var(".concat(RootVariable.INPUT_BASE_PADDING, ")"),
        width: 'fit-content',
        color: "var(".concat(RootVariable.INPUT_ICON_COLOR, ")")
      },
      iconElement: {
        width: "var(".concat(RootVariable.INPUT_ICON_SIZE, ") !important"),
        minWidth: "var(".concat(RootVariable.INPUT_ICON_SIZE, ") !important"),
        height: "var(".concat(RootVariable.INPUT_ICON_SIZE, ") !important"),
        minHeight: "var(".concat(RootVariable.INPUT_ICON_SIZE, ") !important"),
        fontSize: "var(".concat(RootVariable.INPUT_ICON_SIZE, ") !important")
      },
      clear: {
        ref: getRef('clear'),
        cursor: 'pointer',
        display: 'none',
        marginRight: hasRight ? "var(".concat(RootVariable.INPUT_ICON_MARGIN, ")") : 0,
        width: "var(".concat(RootVariable.INPUT_CLEAR_ICON_SIZE, ")"),
        height: "var(".concat(RootVariable.INPUT_CLEAR_ICON_SIZE, ")"),
        color: "var(".concat(RootVariable.INPUT_CLEAR_ICON_COLOR, ")")
      },
      withIcon: {},
      invalid: {},
      disabled: {
        color: "var(".concat(RootVariable.INPUT_DISABLED_COLOR, ")")
      }
    });
  }, {
    size: size
  }, [].concat(_toConsumableArray(isH5MappingAppStyle ? [{
    maxWidth: 'md',
    styles: appStyle
  }] : []), _toConsumableArray(breakpoints)), ThemeBreakpoints);
});
var useInputDynamicStyle = function useInputDynamicStyle(params) {
  var fz = params.fz,
    fw = params.fw;
  return _defineProperty(_defineProperty({}, RootVariable.INPUT_FONT_WEIGHT, fw), RootVariable.INPUT_FONT_SIZE, fz && (isString(fz) ? fz : "".concat(fz, "px")));
};
var useInputWrapperStyle = createStyles(function (_, params) {
  var breakpoints = params.breakpoints,
    size = params.size;
  return addBreakpointMedia(function () {
    return objectDeepMerging(getWrapperCurrentVariantAndSizeStyle({
      size: size
    }), {
      root: {
        fontFamily: 'inherit'
      },
      label: {
        fontFamily: 'inherit',
        fontWeight: "var(".concat(RootVariable.INPUT_WRAPPER_LABEL_FONT_WEIGHT, ")"),
        fontSize: "var(".concat(RootVariable.INPUT_WRAPPER_LABEL_FONT_SIZE, ")"),
        color: "var(".concat(RootVariable.INPUT_WRAPPER_LABEL_COLOR, ")"),
        marginBottom: "var(".concat(RootVariable.INPUT_WRAPPER_LABEL_GAP, ")"),
        lineHeight: "var(".concat(RootVariable.INPUT_WRAPPER_LABEL_LINE_HEIGHT, ")")
      },
      error: {
        fontFamily: 'inherit',
        fontWeight: "var(".concat(RootVariable.INPUT_WRAPPER_ERROR_FONT_WEIGHT, ")"),
        fontSize: "var(".concat(RootVariable.INPUT_WRAPPER_ERROR_FONT_SIZE, ")"),
        color: "var(".concat(RootVariable.INPUT_WRAPPER_ERROR_COLOR, ")"),
        marginTop: "var(".concat(RootVariable.INPUT_WRAPPER_ERROR_GAP, ")"),
        lineHeight: "var(".concat(RootVariable.INPUT_WRAPPER_ERROR_LINE_HEIGHT, ")")
      },
      description: {
        fontFamily: 'inherit',
        fontWeight: "var(".concat(RootVariable.INPUT_WRAPPER_DESC_FONT_WEIGHT, ")"),
        fontSize: "var(".concat(RootVariable.INPUT_WRAPPER_DESC_FONT_SIZE, ")"),
        color: "var(".concat(RootVariable.INPUT_WRAPPER_DESC_COLOR, ")"),
        marginTop: "var(".concat(RootVariable.INPUT_WRAPPER_DESC_GAP, ")"),
        lineHeight: "var(".concat(RootVariable.INPUT_WRAPPER_DESC_LINE_HEIGHT, ")")
      },
      required: {
        color: "var(".concat(RootVariable.INPUT_WRAPPER_REQUIRED_COLOR, ")")
      }
    });
  }, {}, breakpoints, ThemeBreakpoints);
});
var useInputGroupStyle = createStyles(function (_, _ref6) {
  var type = _ref6.type,
    size = _ref6.size;
  return objectDeepMerging(getGroupCurrentVariantAndSizeStyle({
    type: type,
    size: size
  }), {
    root: {
      display: 'flex',
      alignItems: 'center',
      background: "var(".concat(RootVariable.INPUT_BG, ")"),
      borderRadius: "var(".concat(RootVariable.INPUT_RADIUS, ")"),
      boxShadow: "inset 0 0 0 var(".concat(RootVariable.INPUT_BORDER_WIDTH, ") var(").concat(RootVariable.INPUT_BORDER_COLOR, ")"),
      '@media(hover:hover)': {
        '&:hover:not([data-disabled="true"]):not([data-invalid="true"])': {
          boxShadow: "inset 0 0 0 var(".concat(RootVariable.INPUT_BORDER_WIDTH, ") var(").concat(RootVariable.INPUT_HOVER_BORDER_COLOR, ")"),
          background: "var(".concat(RootVariable.INPUT_HOVER_BG, ")")
        }
      },
      '&[data-focus="true"]:not([data-invalid="true"])': {
        boxShadow: "inset 0 0 0 var(".concat(RootVariable.INPUT_BORDER_WIDTH, ") var(").concat(RootVariable.INPUT_ACTIVE_BORDER_COLOR, ")"),
        background: "var(".concat(RootVariable.INPUT_ACTIVE_BG, ")")
      },
      '&[data-invalid="true"]': {
        boxShadow: "inset 0 0 0 var(".concat(RootVariable.INPUT_BORDER_WIDTH, ") var(").concat(RootVariable.INPUT_INVALID_BORDER_COLOR, ")"),
        background: "var(".concat(RootVariable.INPUT_INVALID_BG, ")")
      },
      '&[data-disabled="true"]': {
        boxShadow: "inset 0 0 0 var(".concat(RootVariable.INPUT_BORDER_WIDTH, ") var(").concat(RootVariable.INPUT_DISABLED_BORDER_COLOR, ")"),
        background: "var(".concat(RootVariable.INPUT_DISABLED_BG, ")")
      }
    },
    inputWrapper: {
      width: '100%'
    },
    input: {
      border: 'none !important',
      background: 'transparent !important'
    }
  });
});

export { useInputDynamicStyle, useInputGroupStyle, useInputStyle, useInputWrapperStyle };
//# sourceMappingURL=Input.style.js.map
